import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'
import { useTranslation } from 'react-i18next'

const TranslationalPkPdPage = () => {
  const { t } = useTranslation()
  const parentBreadcrumbs = [
    { label: t('header.home'), path: '/' },
    { label: t('header.service'), path: '/service' },
    { label: t('header.services.aiMl.title'), path: '/service/ai-ml' },
    { label: t('aiMlOverview.drugDiscovery.title'), path: '/service/ai-ml/drug-discovery' }
  ]
  return (
    <TechnicalServicePage 
      serviceKey="translationalPkPd"
      translationKey="bioinformatics.categories.translationalPkPd" 
      parentBreadcrumbs={parentBreadcrumbs}
    />
  )
}

export default TranslationalPkPdPage
